import { render, staticRenderFns } from "./BookingHeader.vue?vue&type=template&id=288954d8&scoped=true"
import script from "./BookingHeader.vue?vue&type=script&lang=js"
export * from "./BookingHeader.vue?vue&type=script&lang=js"
import style0 from "./BookingHeader.vue?vue&type=style&index=0&id=288954d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288954d8",
  null
  
)

export default component.exports